import { createAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export const restoreSession = createAction<Omit<RootState, 'api'>>('restoreSession');
